module.exports = __webpack_public_path__ + "static/media/truck_4t.60116330.svg";